<template>
	<b-modal
		ref="tope-groups-modal"
		size="lg"
		:title="`LISTA DE GRUPOS`"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		style="z-index: 80000"
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Grupos de Topes</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">{{ field.label }}</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="groups.length > 0">
						<b-tr v-for="(group, index) in groups" :key="index">
							<b-td class="text-center">
								{{ group.id ? `Grupo ${group.id}` : "SIN AGRUPAR" }}
							</b-td>
							<b-td class="text-center cursor-pointer" @click="openDraftListModal(group)">
								<span class="underlined font-weight-bold">
									{{ group.pending_drafts }}
								</span>
							</b-td>
							<b-td class="text-center">
								{{ group.created_by || "-" }}
							</b-td>
							<b-td class="text-center">
								<span v-if="group.created_at">
									{{ group.created_at | myGlobalDateTime }}
								</span>
								<span v-else>-</span>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="groups.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
		<ConfrontationDraftListModal
			v-if="showDraftListModal"
			:selectedGroup="selectedGroup"
			@close="showDraftListModal = false"
			@refresh="getRows"
		/>
	</b-modal>
</template>

<script>
import ConfrontationDraftsService from "@/views/amg/videolibrary/confrontation-drafts/services/confrontation-drafts.service.js"
import ConfrontationDraftListModal from "@/views/amg/videolibrary/confrontation-drafts/components/ConfrontationDraftListModal.vue"

export default {
	name: "TopeGroupsModal",
	props: {},
	components: {
		ConfrontationDraftListModal,
	},
	data: () => ({
		isLoading: false,
		fields: [
			{ key: "name", label: "Grupo", class: "text-center" },
			{ key: "pendings", label: "Pendientes", class: "text-center" },
			{ key: "created_by", label: "Creado por", class: "text-center" },
			{
				key: "date",
				label: "FECHA",
				class: "text-center",
			},
		],
		groups: [],
		selectedGroup: null,
		showDraftListModal: false,
	}),
	computed: {},
	methods: {
		openDraftListModal(group) {
			this.selectedGroup = group
			this.showDraftListModal = true
		},
		refresh() {
			this.getRows()
		},
		handleCloseModal() {
			this.$emit("refresh")
			this.$emit("close")
		},
		async getRows() {
			try {
				this.isLoading = true
				const { data } = await ConfrontationDraftsService.listGroups({})
				this.groups = data || []
			} catch (error) {
				console.error("Error fetching average weights report groups:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	mounted() {
		this.$refs["tope-groups-modal"].toggle()
		this.getRows()
	},
}
</script>
<style lang="scss" scoped>
.underlined {
	text-decoration: underline;
}
</style>
